import { useQuery } from "react-query";
import { fetchVideoData } from "./api";

export function useVideo(filters, options={}) {
    return useQuery(["VideoData", filters], () => fetchVideoData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }